import { Flex, Text, useColorModeValue } from '@chakra-ui/react'
import { Mark } from 'components/icons/Mark'
import { MdCampaign } from 'react-icons/md'

const gradient = 'linear-gradient(135deg, #6B7FD7 0%, #3D4FA8 100%)'

type Props = {
  title: string
  subtitle: string
}

export function AdminNotificationContent(props: Props) {
  const textColor = useColorModeValue('navy.700', 'white')
  const mutedColor = useColorModeValue('secondaryGray.600', 'secondaryGray.400')
  return (
    <>
      <Flex
        justify="center"
        align="center"
        borderRadius="16px"
        minH={{ base: '60px', md: '70px' }}
        h={{ base: '60px', md: '70px' }}
        minW={{ base: '60px', md: '70px' }}
        w={{ base: '60px', md: '70px' }}
        me="14px"
        bg={gradient}
      >
        <Mark as={MdCampaign} color="white" w={7} h={7} />
      </Flex>
      <Flex flexDirection="column" align="flex-start" overflow="hidden">
        <Text
          mb="5px"
          fontWeight="bold"
          color={textColor}
          fontSize={{ base: 'md', md: 'md' }}
          noOfLines={1}
          w="100%"
        >
          {props.title}
        </Text>
        <Text fontSize={{ base: 'sm', md: 'sm' }} lineHeight="120%" color={mutedColor} noOfLines={2}>
          {props.subtitle}
        </Text>
      </Flex>
    </>
  )
}
